import React, {useContext, Fragment} from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {change} from "redux-form";

import {setUiPopupState} from "../../../actions/A_Popups";
import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import {sendTwoFaSms} from "./AccountTwoFaApi";
import {getRenderErrorMesssage} from "../../../utilities/backend";


const AccountTwoFaPopupButtons = (props) => {

  const {formValues, setUiPopupState, intl, change} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const isSubmitCodeStep = uiPopupContext.twoFaStep === 1;
  const isSuccessStep = uiPopupContext.twoFaStep === 2;
  const submitDisabled = isSubmitCodeStep && !uiPopupContext.smsCode;

  const sendSmsClick = async () => {
    if (!uiPopupContext.twoFaToken) {
      return
    }
    uiPopupDispatch({
      isLoading: true,
      errorMessage: "",
    });
    const response = await sendTwoFaSms({
      "token": uiPopupContext.twoFaToken,
      "to": formValues.phone1,
      "type": 1
    });
    uiPopupDispatch({
      isLoading: false,
      errorMessage: response.__errorMessage__ ? response.__errorMessage__ : "",
      twoFaStep: response.__errorMessage__ ? 0 : 1,
    });
    const input = document.getElementById("phoneInput");
    if (input) {
      input.focus();
    }
  }

  const submitCodeClick = async () => {
    if (!uiPopupContext.smsCode) {
      return
    }
    uiPopupDispatch({
      isLoading: true,
      errorMessage: "",
    });
    try {
      const response = await sendTwoFaSms({
        "token": uiPopupContext.twoFaToken,
        "PhoneNumber": formValues.phone1,
        "code": uiPopupContext.smsCode,
      });
      const codeSuccess = !!response;
      uiPopupDispatch({
        isLoading: false,
        errorMessage: codeSuccess ? "" : intl.formatMessage({id: "twoFA.invalidCode"}),
        twoFaStep: codeSuccess ? 2 : 1,
      });
      if (codeSuccess) {
        change('newEntity', "verifiedPhoneNumber", true);
      }
      //
    } catch (response) {
      uiPopupDispatch({
        errorMessage: getRenderErrorMesssage(response),
        isLoading: false,
      });
    }
  }

  return (
    <div className="inline-block relative">
      {isSubmitCodeStep ? (
        <button className={"ui-button5 m-0 ui-button5--blue mr-05"}
                onClick={() => uiPopupDispatch({twoFaStep: 0, errorMessage: "", smsCode: ""})}>
          <FormattedMessage id="messageBox.buttons.back"/>
        </button>
      ) : null}
      {isSuccessStep ? (
        <button className={"ui-button5 m-0 ui-button5--blue mr-05"}
                onClick={() => setUiPopupState({opened: false})}>
          <FormattedMessage id="messageBox.buttons.close"/>
        </button>
      ) : (
        <Fragment>
          <button className={"ui-button5 m-0 ui-button5--green" + (submitDisabled ? " ui-button5--disabled" : "")}
                  onClick={submitDisabled ? null : isSubmitCodeStep ? submitCodeClick : sendSmsClick}>
            {isSubmitCodeStep ? "Submit code" : "Send Sms"}
          </button>
          {uiPopupContext.isLoading
            ? <div className="absolute ml-05 mt-025 top-0 ui-loader ui-loader--small"/>
            : null}
        </Fragment>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  // const {auth, asCustomer} = state;
  return {
    // auth,
    // asCustomer,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  setUiPopupState,
  change,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AccountTwoFaPopupButtons)
)
